// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__mt2Vi","selected":"Chip_selected__2Nrfw"};